import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["wrist-heart-rate"]!;

export function Body() {
  return (
    <>
      <p>
        Most runners measure heart rate with the sensor on the back of their watch. How close
        is it to the real value? A study from the Cleveland Clinic compared wrist sensors with a
        chest strap and an ECG.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Fifty healthy adults exercised on a treadmill, a stationary bike and an elliptical
        trainer at rest, light, moderate and hard effort. Their heart rate was measured with an
        ECG, a chest strap, a forearm sensor and wrist-worn sensors from four brands.
      </p>

      <h2>What they found</h2>
      <p>
        The chest strap was almost identical to the ECG. The wrist sensors varied: the best came
        close, while others were clearly less accurate.
      </p>
      <p>
        Running on the treadmill gave the best results, and most wrist sensors performed well
        there. On the bike and on the elliptical trainer, accuracy was lower, and with arm
        movement on the elliptical none of the sensors were accurate.
      </p>

      <h2>What it means for you</h2>
      <p>
        For steady running, a modern wrist sensor is often good enough. For intervals, rapid
        changes in effort and activities where you grip or move your arms a lot, a chest strap is
        more reliable.
      </p>
      <p>
        If a reading looks strange, such as a very high heart rate early in an easy run, it is
        often the sensor and not your heart. Check how the run feels.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The study tested watches from 2017. Sensors have improved since then, and accuracy
        varies with fit, skin, temperature and movement. Running outdoors was not tested.
      </p>

      <h2>How we use it</h2>
      <p>
        Targets in PX7 Training are set as pace or power, so a wrong heart-rate reading doesn't
        change your session. If you use heart rate to keep easy runs easy, a chest strap gives
        you a more reliable number.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Gillinov et al. (2017), Variable accuracy of wearable heart rate monitors during
          aerobic exercise.{" "}
          <a href="https://doi.org/10.1249/MSS.0000000000001284">Medicine & Science in Sports & Exercise</a>.
        </li>
      </ul>
    </>
  );
}
